module.exports = __webpack_public_path__ + "static/media/ckn_pedidos_filtros.0131ad90.jpg";